// Final legal texts (Impressum / Datenschutz / AGB) + cookie-consent strings.
// Kept separate from translations.js for clean multi-line authoring.

export const LEGAL_CONTENT = {
  de: {
    impressum: {
      title: "Impressum",
      body: `Kontaktdaten
MYSYMP AG
Studenstrasse 14B
CH-6207 Nottwil
Schweiz

E-Mail: info@mysymp.ch
Web: www.mysymp.ch
Telefon: +41 79 471 06 25

Vertretungsberechtigte Personen
Isidoro Celentano — CEO / Founder

Handelsregistereintrag
Eingetragener Firmenname: MYSYMP AG
Nummer: CHE-192.170.455
Handelsregisteramt: Nottwil

Mehrwertsteuernummer
CHE-192.170.455 MWST

Haftungsausschluss
Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität wird keine Gewähr übernommen. Für Inhalte externer Links sind ausschliesslich deren Betreiber verantwortlich.

Urheberrecht
© MYSYMP AG. Alle Rechte vorbehalten.`,
    },
    privacy: {
      title: "Datenschutzerklärung",
      body: `Diese Datenschutzerklärung informiert Sie darüber, wie die MYSYMP AG Ihre Personendaten bearbeitet – im Einklang mit dem revidierten Schweizer Datenschutzgesetz (revDSG) sowie, soweit anwendbar, der EU-Datenschutz-Grundverordnung (DSGVO).

1. Verantwortliche Stelle
MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Schweiz
E-Mail: info@mysymp.ch · Telefon: +41 79 471 06 25

2. Bearbeitete Personendaten
– Daten, die Sie uns aktiv übermitteln (Kontaktformular, Terminbuchung, Newsletter, Bestellungen): z. B. Name, E-Mail, Telefon, Nachricht.
– Technische Daten, die beim Besuch automatisch anfallen (Server-Logfiles: gekürzte IP-Adresse, Datum/Uhrzeit, abgerufene Seite, Browser/Gerät).
– Nutzungsdaten aus Analyse-Tools (nur mit Ihrer Einwilligung, siehe Ziff. 6).

3. Zwecke und Rechtsgrundlagen
Wir bearbeiten Ihre Daten zur Beantwortung von Anfragen, zur Organisation von Terminen, zum Versand des Newsletters (nur mit Einwilligung), zur Abwicklung von Bestellungen sowie zum sicheren Betrieb und zur Verbesserung der Website. Rechtsgrundlagen sind Ihre Einwilligung, die Vertragserfüllung sowie unsere berechtigten Interessen an einem sicheren, funktionsfähigen Angebot.

4. Server-Logfiles
Aus Sicherheits- und Betriebsgründen werden technische Zugriffsdaten protokolliert und nach kurzer Zeit gelöscht bzw. anonymisiert.

5. Cookies
Wir verwenden technisch notwendige Cookies für den Betrieb der Website (z. B. zum Speichern Ihrer Sprach- und Cookie-Einstellungen). Nicht notwendige Cookies (Analyse) werden nur mit Ihrer Einwilligung gesetzt. Ihre Einwilligung können Sie jederzeit über die Cookie-Einstellungen im Seitenfuss anpassen.

6. Webanalyse (PostHog)
Mit Ihrer Einwilligung setzen wir PostHog zur pseudonymen Analyse der Websitenutzung ein, um unser Angebot zu verbessern. Ohne Einwilligung findet keine Analyse und keine Sitzungsaufzeichnung statt. Sie können die Einwilligung jederzeit widerrufen.

7. Kontaktformular, Terminbuchung & Newsletter
Die in diesen Formularen erhobenen Daten verwenden wir ausschliesslich zur Bearbeitung Ihres Anliegens. Der Newsletter erfolgt nur nach Anmeldung und kann jederzeit abbestellt werden.

8. Zahlungen (Shop)
Bei künftigen Käufen von E-Books erfolgt die Zahlungsabwicklung über spezialisierte Zahlungsdienstleister (z. B. Stripe, inkl. TWINT und PayPal). Diese bearbeiten die Zahlungsdaten eigenverantwortlich; wir erhalten keine vollständigen Kartendaten.

9. Auftragsbearbeiter und Weitergabe
Wir setzen sorgfältig ausgewählte Dienstleister (Hosting, E-Mail-Versand, Zahlungsabwicklung, Analyse) ein, die Daten nur weisungsgebunden bearbeiten. Eine Weitergabe erfolgt nur, soweit erforderlich oder gesetzlich vorgeschrieben.

10. Datenübermittlung ins Ausland
Einzelne Dienstleister können Daten im Ausland (z. B. EU/USA) bearbeiten. In diesen Fällen sorgen wir für einen angemessenen Schutz durch geeignete Garantien (z. B. Standardvertragsklauseln).

11. Aufbewahrung
Wir bewahren Personendaten nur so lange auf, wie dies für die genannten Zwecke oder gesetzliche Aufbewahrungspflichten erforderlich ist.

12. Ihre Rechte
Sie haben im Rahmen des anwendbaren Rechts das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit sowie auf Widerruf erteilter Einwilligungen. Wenden Sie sich an info@mysymp.ch. Zudem steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu (in der Schweiz: EDÖB).

13. Datensicherheit
Die Website wird verschlüsselt (SSL/TLS) übertragen. Wir treffen angemessene technische und organisatorische Massnahmen zum Schutz Ihrer Daten.

14. Änderungen
Wir können diese Datenschutzerklärung anpassen. Massgebend ist die jeweils auf dieser Seite veröffentlichte Fassung.

Stand: Juni 2026`,
    },
    terms: {
      title: "Allgemeine Geschäftsbedingungen (AGB)",
      body: `1. Geltungsbereich
Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der Website der MYSYMP AG sowie für alle darüber angebotenen Leistungen und digitalen Produkte (insbesondere E-Books).

2. Anbieterin
MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Schweiz · info@mysymp.ch

3. Leistungen
Die MYSYMP AG präsentiert kuratierte Lebenswelten (Interior, Fashion, Real Estate, Wein), strategische Beratung sowie digitale Publikationen. Beratungs- und Mandatsleistungen werden individuell vereinbart.

4. Digitale Produkte (E-Books)
E-Books sind digitale Inhalte, die nach dem Kauf sofort zum Download bereitstehen. Preise verstehen sich in Schweizer Franken (CHF), inkl. allfälliger gesetzlicher Steuern.

5. Vertragsschluss & Zahlung
Der Vertrag kommt mit Abschluss des Bestellvorgangs zustande. Die Zahlung erfolgt über die angebotenen Zahlungsmittel (künftig u. a. Stripe, TWINT, PayPal).

6. Widerruf bei digitalen Inhalten
Bei digitalen Inhalten, die sofort bereitgestellt werden, erlischt ein allfälliges Widerrufsrecht mit Beginn des Downloads bzw. mit Ihrer ausdrücklichen Zustimmung zur sofortigen Bereitstellung.

7. Termine & Beratung
Vereinbarte Termine können bis 24 Stunden vorher kostenfrei verschoben oder abgesagt werden.

8. Haftung
Die MYSYMP AG haftet nur für Schäden aus grober Fahrlässigkeit oder Vorsatz, soweit gesetzlich zulässig. Für Inhalte externer, verlinkter Websites wird keine Haftung übernommen.

9. Urheberrecht
Alle Inhalte dieser Website (Texte, Bilder, Gestaltung, E-Books) sind urheberrechtlich geschützt. Eine Nutzung ausserhalb des persönlichen Gebrauchs bedarf der schriftlichen Zustimmung.

10. Anwendbares Recht & Gerichtsstand
Es gilt ausschliesslich schweizerisches Recht. Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz der MYSYMP AG in Nottwil.

Stand: Juni 2026`,
    },
  },

  en: {
    impressum: {
      title: "Imprint",
      body: `Contact
MYSYMP AG
Studenstrasse 14B
CH-6207 Nottwil
Switzerland

Email: info@mysymp.ch
Web: www.mysymp.ch
Phone: +41 79 471 06 25

Authorised representatives
Isidoro Celentano — CEO / Founder

Commercial register
Registered company name: MYSYMP AG
Number: CHE-192.170.455
Commercial register office: Nottwil

VAT number
CHE-192.170.455 MWST

Disclaimer
The content of this website has been compiled with the greatest care. However, no guarantee is given as to its accuracy, completeness or timeliness. The operators of external linked sites are solely responsible for their content.

Copyright
© MYSYMP AG. All rights reserved.`,
    },
    privacy: {
      title: "Privacy Policy",
      body: `This privacy policy explains how MYSYMP AG processes your personal data in accordance with the revised Swiss Federal Act on Data Protection (revFADP) and, where applicable, the EU General Data Protection Regulation (GDPR).

1. Controller
MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Switzerland
Email: info@mysymp.ch · Phone: +41 79 471 06 25

2. Data we process
– Data you actively provide (contact form, booking, newsletter, orders): e.g. name, email, phone, message.
– Technical data collected automatically on your visit (server log files: shortened IP address, date/time, page requested, browser/device).
– Usage data from analytics tools (only with your consent, see section 6).

3. Purposes and legal bases
We process your data to respond to enquiries, organise appointments, send the newsletter (only with consent), handle orders and operate and improve the website securely. Legal bases are your consent, contract performance and our legitimate interests in a secure, functioning service.

4. Server log files
For security and operational reasons, technical access data is logged and deleted or anonymised after a short period.

5. Cookies
We use strictly necessary cookies to operate the website (e.g. to store your language and cookie preferences). Non-essential (analytics) cookies are only set with your consent. You can adjust your consent at any time via the cookie settings in the footer.

6. Web analytics (PostHog)
With your consent we use PostHog for pseudonymous analysis of website usage in order to improve our services. Without consent, no analysis and no session recording take place. You can withdraw consent at any time.

7. Contact form, booking & newsletter
Data collected in these forms is used solely to process your request. The newsletter is only sent after sign-up and can be cancelled at any time.

8. Payments (shop)
For future e-book purchases, payments are handled by specialised payment providers (e.g. Stripe, incl. TWINT and PayPal), which process payment data under their own responsibility; we do not receive full card details.

9. Processors and disclosure
We use carefully selected service providers (hosting, email delivery, payment processing, analytics) that process data only on our instructions. Data is disclosed only where necessary or legally required.

10. International data transfers
Some providers may process data abroad (e.g. EU/USA). In such cases we ensure an adequate level of protection through appropriate safeguards (e.g. standard contractual clauses).

11. Retention
We retain personal data only as long as necessary for the stated purposes or to meet legal retention obligations.

12. Your rights
Subject to applicable law, you have the right to access, rectification, erasure, restriction, data portability and to withdraw consent. Please contact info@mysymp.ch. You also have the right to lodge a complaint with the competent supervisory authority (in Switzerland: FDPIC).

13. Data security
The website is transmitted using encryption (SSL/TLS). We take appropriate technical and organisational measures to protect your data.

14. Changes
We may update this privacy policy. The version published on this page applies.

Last updated: June 2026`,
    },
    terms: {
      title: "Terms & Conditions",
      body: `1. Scope
These general terms and conditions (T&C) apply to the use of the MYSYMP AG website and to all services and digital products offered through it (in particular e-books).

2. Provider
MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Switzerland · info@mysymp.ch

3. Services
MYSYMP AG presents curated worlds (interior, fashion, real estate, wine), strategic advisory and digital publications. Advisory and mandate services are agreed individually.

4. Digital products (e-books)
E-books are digital content available for download immediately after purchase. Prices are in Swiss francs (CHF), incl. any applicable taxes.

5. Conclusion of contract & payment
The contract is concluded upon completion of the order. Payment is made via the offered methods (in future incl. Stripe, TWINT, PayPal).

6. Withdrawal for digital content
For digital content made available immediately, any right of withdrawal expires once the download begins or upon your express consent to immediate provision.

7. Appointments & advisory
Booked appointments can be rescheduled or cancelled free of charge up to 24 hours in advance.

8. Liability
MYSYMP AG is liable only for damage caused by gross negligence or intent, to the extent permitted by law. No liability is accepted for the content of external linked websites.

9. Copyright
All content on this website (texts, images, design, e-books) is protected by copyright. Any use beyond personal use requires written consent.

10. Applicable law & place of jurisdiction
Swiss law applies exclusively. The place of jurisdiction is, to the extent legally permissible, the registered office of MYSYMP AG in Nottwil.

Last updated: June 2026`,
    },
  },

  fr: {
    impressum: {
      title: "Mentions légales",
      body: `Coordonnées
MYSYMP AG
Studenstrasse 14B
CH-6207 Nottwil
Suisse

E-mail : info@mysymp.ch
Web : www.mysymp.ch
Téléphone : +41 79 471 06 25

Personnes autorisées à représenter
Isidoro Celentano — CEO / Founder

Inscription au registre du commerce
Raison sociale : MYSYMP AG
Numéro : CHE-192.170.455
Office du registre du commerce : Nottwil

Numéro de TVA
CHE-192.170.455 TVA

Clause de non-responsabilité
Les contenus de ce site ont été élaborés avec le plus grand soin. Aucune garantie n'est toutefois donnée quant à leur exactitude, exhaustivité ou actualité. Les exploitants des sites externes liés sont seuls responsables de leur contenu.

Droit d'auteur
© MYSYMP AG. Tous droits réservés.`,
    },
    privacy: {
      title: "Politique de confidentialité",
      body: `La présente politique de confidentialité explique comment MYSYMP AG traite vos données personnelles conformément à la loi fédérale suisse révisée sur la protection des données (nLPD) et, le cas échéant, au Règlement général sur la protection des données de l'UE (RGPD).

1. Responsable du traitement
MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Suisse
E-mail : info@mysymp.ch · Téléphone : +41 79 471 06 25

2. Données traitées
– Données que vous fournissez activement (formulaire de contact, réservation, newsletter, commandes) : p. ex. nom, e-mail, téléphone, message.
– Données techniques collectées automatiquement lors de votre visite (fichiers journaux : adresse IP abrégée, date/heure, page consultée, navigateur/appareil).
– Données d'utilisation issues d'outils d'analyse (uniquement avec votre consentement, voir point 6).

3. Finalités et bases légales
Nous traitons vos données pour répondre aux demandes, organiser les rendez-vous, envoyer la newsletter (uniquement avec consentement), traiter les commandes et exploiter et améliorer le site en toute sécurité. Les bases légales sont votre consentement, l'exécution du contrat et nos intérêts légitimes à un service sûr et fonctionnel.

4. Fichiers journaux
Pour des raisons de sécurité et d'exploitation, des données techniques d'accès sont enregistrées puis supprimées ou anonymisées après une courte période.

5. Cookies
Nous utilisons des cookies strictement nécessaires au fonctionnement du site (p. ex. pour mémoriser vos préférences de langue et de cookies). Les cookies non essentiels (analyse) ne sont déposés qu'avec votre consentement. Vous pouvez modifier votre consentement à tout moment via les paramètres de cookies en pied de page.

6. Analyse web (PostHog)
Avec votre consentement, nous utilisons PostHog pour une analyse pseudonyme de l'utilisation du site afin d'améliorer nos services. Sans consentement, aucune analyse ni aucun enregistrement de session n'ont lieu. Vous pouvez retirer votre consentement à tout moment.

7. Formulaire de contact, réservation & newsletter
Les données collectées dans ces formulaires servent uniquement à traiter votre demande. La newsletter n'est envoyée qu'après inscription et peut être résiliée à tout moment.

8. Paiements (boutique)
Pour les futurs achats d'e-books, les paiements sont gérés par des prestataires spécialisés (p. ex. Stripe, incl. TWINT et PayPal), qui traitent les données de paiement sous leur propre responsabilité ; nous ne recevons pas les données complètes de carte.

9. Sous-traitants et transmission
Nous faisons appel à des prestataires soigneusement sélectionnés (hébergement, envoi d'e-mails, paiement, analyse) qui ne traitent les données que sur nos instructions. Une transmission n'a lieu que si nécessaire ou légalement requise.

10. Transferts de données à l'étranger
Certains prestataires peuvent traiter des données à l'étranger (p. ex. UE/USA). Dans ces cas, nous assurons un niveau de protection adéquat par des garanties appropriées (p. ex. clauses contractuelles types).

11. Conservation
Nous ne conservons les données personnelles que le temps nécessaire aux finalités indiquées ou aux obligations légales de conservation.

12. Vos droits
Sous réserve du droit applicable, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, de portabilité et de retrait du consentement. Contact : info@mysymp.ch. Vous avez également le droit d'introduire une réclamation auprès de l'autorité de contrôle compétente (en Suisse : PFPDT).

13. Sécurité des données
Le site est transmis de manière chiffrée (SSL/TLS). Nous prenons des mesures techniques et organisationnelles appropriées pour protéger vos données.

14. Modifications
Nous pouvons adapter la présente politique. La version publiée sur cette page fait foi.

Dernière mise à jour : juin 2026`,
    },
    terms: {
      title: "Conditions générales (CGV)",
      body: `1. Champ d'application
Les présentes conditions générales (CGV) s'appliquent à l'utilisation du site de MYSYMP AG ainsi qu'à toutes les prestations et produits numériques proposés (en particulier les e-books).

2. Fournisseur
MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Suisse · info@mysymp.ch

3. Prestations
MYSYMP AG présente des univers curatés (intérieur, mode, immobilier, vin), du conseil stratégique et des publications numériques. Les prestations de conseil et de mandat sont convenues individuellement.

4. Produits numériques (e-books)
Les e-books sont des contenus numériques disponibles au téléchargement immédiatement après l'achat. Les prix s'entendent en francs suisses (CHF), taxes légales éventuelles incluses.

5. Conclusion du contrat & paiement
Le contrat est conclu à la finalisation de la commande. Le paiement s'effectue via les moyens proposés (à l'avenir : Stripe, TWINT, PayPal).

6. Rétractation pour les contenus numériques
Pour les contenus numériques fournis immédiatement, tout droit de rétractation s'éteint dès le début du téléchargement ou dès votre consentement exprès à la fourniture immédiate.

7. Rendez-vous & conseil
Les rendez-vous convenus peuvent être reportés ou annulés gratuitement jusqu'à 24 heures à l'avance.

8. Responsabilité
MYSYMP AG n'est responsable qu'en cas de faute grave ou intentionnelle, dans la mesure permise par la loi. Aucune responsabilité n'est assumée pour le contenu de sites externes liés.

9. Droit d'auteur
Tous les contenus de ce site (textes, images, design, e-books) sont protégés par le droit d'auteur. Toute utilisation au-delà de l'usage personnel requiert un accord écrit.

10. Droit applicable & for
Le droit suisse s'applique exclusivement. Le for est, dans la mesure légalement admissible, le siège de MYSYMP AG à Nottwil.

Dernière mise à jour : juin 2026`,
    },
  },
};

export const COOKIE_TEXT = {
  de: {
    title: "Wir respektieren Ihre Privatsphäre",
    text: "Wir verwenden notwendige Cookies für den Betrieb der Website und – nur mit Ihrer Einwilligung – Analyse-Cookies, um unser Angebot zu verbessern.",
    accept: "Alle akzeptieren",
    essential: "Nur notwendige",
    settings: "Cookie-Einstellungen",
    more: "Mehr in der Datenschutzerklärung",
  },
  en: {
    title: "We respect your privacy",
    text: "We use necessary cookies to operate the website and — only with your consent — analytics cookies to improve our services.",
    accept: "Accept all",
    essential: "Essential only",
    settings: "Cookie settings",
    more: "More in the privacy policy",
  },
  fr: {
    title: "Nous respectons votre vie privée",
    text: "Nous utilisons des cookies nécessaires au fonctionnement du site et — uniquement avec votre consentement — des cookies d'analyse pour améliorer nos services.",
    accept: "Tout accepter",
    essential: "Uniquement nécessaires",
    settings: "Paramètres des cookies",
    more: "En savoir plus dans la politique de confidentialité",
  },
};
